import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { DialogContextType } from "../../DialogComponents/FullScreenDialog";

export const useContext = (): DialogContextType => {
  const { t } = useTranslation("dialogs");

  return useMemo(
    () => ({
      title: {
        icon: "share",
      },
      applyText: t("shareProject.saveAndShare"),
    }),
    [t],
  );
};
